
export const BOOKING_CARD_WIDTH = 236;
export const BOOKING_CARD_HEIGHT = 84;

export const DRAGGABLE_CARD_W = 140;
export const DRAGGABLE_CARD_H = 54;
// UI-1459
export const OUTER_VIEW_X = 10;
export const OUTER_VIEW_Y = 0;

export const sectionTitleSize = {
  width: 0,
  height: 50,
};
export const sectionLayoutPadding = 15;
